import { FunctionComponent } from 'react'
import { useAuth } from '@/modules/context/AuthContext'
import { RequireAuth } from '@/modules/routes/requireAuth'
import { Role } from '@/types/Role'
import ParentNotification from './parentNotification/parentNotification'
import StaffNotification from './staffNotification/staffNotification'

const AccountNotification: FunctionComponent = () => {
    const { user } = useAuth()

    return (
        <RequireAuth roles={[Role.parent, Role.staff]}>
            <>
                {user && user.role == Role.parent && <ParentNotification />}
                {user && user.role == Role.staff && <StaffNotification />}
            </>
        </RequireAuth>
    )
}

export default AccountNotification
